var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_10406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98924 1.33203H3.99591C3.64268 1.33203 3.30392 1.47235 3.05415 1.72212C2.80438 1.97189 2.66406 2.31065 2.66406 2.66388V13.3187C2.66406 13.6719 2.80438 14.0107 3.05415 14.2604C3.30392 14.5102 3.64268 14.6505 3.99591 14.6505H11.987C12.3402 14.6505 12.679 14.5102 12.9288 14.2604C13.1785 14.0107 13.3189 13.6719 13.3189 13.3187V4.66166L9.98924 1.33203Z",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32324 1.33203V3.99573C9.32324 4.34896 9.46356 4.68772 9.71333 4.93749C9.9631 5.18726 10.3019 5.32758 10.6551 5.32758H13.3188",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.659 5.99316H5.32715",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6545 8.65723H5.32715",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6545 11.3203H5.32715",
    stroke: "#99A1AF",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_10406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/fileicon.e42ae8775445c332114c3e6ceda6a79c.svg";
export { ForwardRef as ReactComponent };